import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { ApiResult } from '../model';

export const axiosInstance = axios.create({
  baseURL:
    process.env.REACT_APP_CRM_API_HOST ?? 'https://crm-api-dev.frism.io/',
  timeout: 15 * 1000,
});

export const customAxios = async <T>(
  config: AxiosRequestConfig,
): Promise<T> => {
  const method = config.method ?? 'GET';
  const url = config.url;

  console.log(method, url);

  if (!config.headers) {
    config.headers = {};
  }

  if (config.baseURL !== process.env.REACT_APP_CRM_API_HOST) {
    config.baseURL = process.env.REACT_APP_CRM_API_HOST;
  }

  const response: AxiosResponse<T> = await axiosInstance(config);
  return response.data;
};

export class FrismError<T> extends AxiosError<T> {}

export interface ErrorType<Error> extends FrismError<Error> {}

export type CustomErrorType = FrismError<ApiResult>;
